import { useAuth0 } from "@/Contexts";
import { IconError } from "@/Icons/Error";
import { Button } from "@/components/button";
import { Translate, useTrans } from "@/translations";

type Props = {
  errorTitle?: string;
  errorMessage?: string;
};

export const ErrorPage: React.FC<Props> = ({
  errorTitle = "errors:failToFetch",
  errorMessage,
}) => {
  const { t } = useTrans();
  const { logout } = useAuth0()!;

  return (
    <div className="bg-grey1 fixed top-0 right-0 bottom-0 left-0 flex items-center justify-center">
      <Button
        className="absolute top-4 right-4"
        onClick={() =>
          logout({ logoutParams: { returnTo: window.location.origin } })
        }
        label={t("actions:logout")}
      />

      <h1 className="font-signifier w-[920px] text-center text-3xl">
        <div className="mb-5 flex justify-center">
          <IconError width={60} height={60} />
        </div>
        <div className="mb-3 font-semibold">
          <Translate i18nKey={errorTitle} />
        </div>
        {errorMessage && (
          <div className="text-carrot-red mt-5 mb-8 text-xl">
            <Translate i18nKey={errorMessage} />
          </div>
        )}
        <Translate
          i18nKey={"errors:somethingWentWrong"}
          components={[
            // Anchor content is added by the translation
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a href="mailto:support@carrot.tech" className="underline" />,
          ]}
        />
      </h1>
    </div>
  );
};

export default ErrorPage;
